import React from "react";
import { STATUS } from "../constants/config";

const StatusDot = ({ status }) => {
  const s = STATUS[status];
  if (!s) return null;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        fontSize: 10,
        color: s.color,
        fontWeight: 600,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: status === "blocked" ? 1 : "50%",
          background: s.color,
          display: "inline-block",
        }}
      />
    </span>
  );
};

export default StatusDot;
